import { render, staticRenderFns } from "./PG010MainPage.vue?vue&type=template&id=487f9a6c&v-cloak=true&"
import script from "./PG010MainPage.vue?vue&type=script&lang=js&"
export * from "./PG010MainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports